import { useThemeSlice } from "../../../components/ui/StatusBadge.jsx";
import { userInitials } from "../../Users/userUtils.js";
import { AccountPermissionRoleSelect } from "./AccountPermissionRoleSelect.jsx";

export function AccountPermissionUserList({ items, ap, saving, onChangeRole }) {
  const { c } = useThemeSlice();

  return (
    <div style={{ overflow: "auto", flex: 1 }}>
      <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
        <thead>
          <tr style={{ background: c.hover }}>
            <th style={th(c, ap, { width: "34%" })}>User</th>
            <th style={th(c, ap)}>Email</th>
            <th style={th(c, ap, { width: 160 })}>Role</th>
          </tr>
        </thead>
        <tbody>
          {items.map((user) => (
            <AccountPermissionUserRow
              key={user.id}
              user={user}
              c={c}
              saving={saving}
              onChangeRole={onChangeRole}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
}

function AccountPermissionUserRow({ user, c, saving, onChangeRole }) {
  const initials = userInitials(user.name);

  return (
    <tr
      onMouseEnter={(e) => (e.currentTarget.style.background = c.hover)}
      onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
      style={{ transition: "background .15s ease" }}
    >
      <td style={td(c)}>
        <div style={{ display: "flex", alignItems: "center", gap: 12, minWidth: 0 }}>
          <UserAvatar initials={initials} />
          <div style={{ minWidth: 0 }}>
            <div style={{ fontWeight: 700, color: c.text, fontSize: 13.5, lineHeight: 1.3 }}>{user.name}</div>
          </div>
        </div>
      </td>
      <td style={{ ...td(c), color: c.mid, fontSize: 12.5 }}>{user.email}</td>
      <td style={td(c)}>
        <AccountPermissionRoleSelect
          value={user.role}
          onChange={(role) => onChangeRole(user.id, role)}
          disabled={saving}
        />
      </td>
    </tr>
  );
}

function UserAvatar({ initials }) {
  const hue = [...initials].reduce((sum, ch) => sum + ch.charCodeAt(0), 0) % 360;
  const bg = `hsl(${hue} 62% 92%)`;
  const color = `hsl(${hue} 48% 36%)`;
  const border = `hsl(${hue} 45% 82%)`;

  return (
    <span
      style={{
        width: 36,
        height: 36,
        borderRadius: 10,
        flexShrink: 0,
        display: "grid",
        placeItems: "center",
        background: bg,
        border: `1px solid ${border}`,
        color,
        fontSize: 11,
        fontWeight: 800,
        letterSpacing: "0.03em",
      }}
    >
      {initials}
    </span>
  );
}

function th(c, ap, extra = {}) {
  return {
    textAlign: "left",
    padding: "11px 14px",
    color: c.sub,
    fontWeight: 700,
    fontSize: 10.5,
    letterSpacing: "0.06em",
    textTransform: "uppercase",
    borderBottom: `1px solid ${ap.cardBorder}`,
    whiteSpace: "nowrap",
    position: "sticky",
    top: 0,
    background: c.hover,
    zIndex: 1,
    ...extra,
  };
}

function td(c) {
  return { padding: "14px", borderBottom: `1px solid ${c.divider}`, color: c.text, verticalAlign: "middle" };
}
